<template>
  <div class="menuBox">
    <div class="content">
     <div >
      <div class="imgBox" @click="goHome"> <img  :src="logo" alt="" class="img"></div>
        <div>
            <ul>
                <li v-for="(item,index) in navList" :key="index" @click="clickmenu(item,index)" :class="{'active':activeIndex == index,'default':activeIndex != index, 'border-active-t':activeIndex == index+1,'border-active-b':activeIndex == index-1}">
                    <i :class="item.des" style="font-size: 20px;margin-right: 8px;"></i>
                    <span>{{ item.name.substr(0,1) }}</span> <span>{{ item.name.substr(1,1) }}</span>
                </li>
            </ul>
        </div>
     </div>
        <div style="background: #1b213f;height: 100%;" :class="{'border-active-b':isShow}">
        </div>
    </div>
    <!-- 二级菜单 -->
    <div class="secondBox" v-if="secondMenu != ''">
        <div class="secondTitle">{{ secondMenu.name }}</div>
        <div v-for="(item,index) in secondMenu.child" :key="index" @click="secondMenuData(item,index)" :class="secondIndex == index ?'secondText':''" class="secondListBox">
        <span class="secondList">{{ item.name }}</span>
        <img src="../assets/collect2.png" alt="" class="Img" v-if="secondIndex == index && item.checked && item.is_shortcut == 0" @click.stop="collect(item,index)">
        <img src="../assets/collect1.png" alt="" class="Img" v-if="secondIndex != index &&!item.checked && item.is_shortcut == 0" @click.stop="collect(item,index)">
        <img src="../assets/cancel2.png" alt="" class="Img" v-if="secondIndex == index &&item.checked && item.is_shortcut == 1" @click.stop="collect(item,index)">
        <img src="../assets/cancel1.png" alt="" class="Img" v-if="secondIndex != index &&!item.checked && item.is_shortcut == 1" @click.stop="collect(item,index)">
        </div>
    </div>
  </div>
</template>

<script>
import {
  UserPage,
  allocation,
  companyid,
  userlevelpages,
  usershortcutmenus
} from "../../static/API/API.js";
export default {
  props: ['activeIndexs','secondIndexs','menuItemData','editableTabs'],
    data(){
        return{
            logo:require('../assets/menuLogo.png'),
            navList:[],
            activeIndex:null,
            secondMenu:'',
            secondIndex:null,
            isShow:false,
            aindex:null,
        }
    },
    watch: {
      menuItemData: function (newData) {
        this.secondMenu = newData
    },
     activeIndexs: function (newData) {
        this.activeIndex = newData
    },
     secondIndexs: function (newData) {
        // this.secondIndex = newData
        // this.secondMenu = newData.child.map(item=>{
        //   item.checked = false
        // })
        this.secondMenu.child.map((item,index)=>{
          item.checked = false
          if(index == newData){
            item.checked = true
          }
        })
        this.secondIndex = newData
        // setTimeout(()=>{
        //   console.log(newData,'newData');
        //   console.log( this.secondMenu,' this.secondMenu');
        // },200)
        // this.secondMenu.child.map((item,index)=>{
        //   if(index == secondIndex){
        //     item.checked = true
        //   }
        // })
    },
     editableTabs: function (newData) {
      if(newData.length == 0){
        this.$router.push(this.secondMenu.child[0].page,()=>{}, ()=>{})
        this.$emit('closeMenu',this.secondMenu.child[0])
        this.secondMenu.child.map(item=>{
          item.checked = false
        })
        this.secondIndex = 0
        this.secondMenu.child[0].checked = true
        this.secondMenu = ''
        this.activeIndex = null
        this.isShow = false
      }
    }
  },
    methods:{
            //获取页面配置信息
    basic() {
      let params = new URLSearchParams();
      params.append("page_size", "all");
      params.append("page_number", 1);
      params.append("companyid", sessionStorage.getItem("companyid"));
      this.$axios
        .get(allocation, {
          params,
        })
        .then((res) => {
          res.data[0]["pagedata"].forEach((e) => {
            if (e.name == "系统logo") {
              // this.logo = e.message;
            }
          });
        });
    },
    // 点击收藏
    collect(item,index){
      console.log(item,'2222222222');
      let params = new URLSearchParams();
      params.append('page_id', item.id)
      this.$axios.post(usershortcutmenus, params).then(res=> {
        console.log(res);
        if(res.status == 200){
          setTimeout(()=>{
            this.$message({
              type: 'success',
              message: res.data,
              duration: 1000,
              showClose: true,
          });
          },200)
        }
        this.pagefeed()
      })
    },
    pagefeed() {
      setTimeout(()=>{
      this.$axios
        .get(userlevelpages, {})
        .then((res) => {
        this.navList = res.data;
        this.navList.map((item,index)=>{
        item.child && item.child.map((val,i)=>{
          if(this.$route.name == val.page){
            this.secondMenu = item
            this.activeIndex = index
            this.secondIndex = i
            val.checked = true
          }
        })
      })
        });
      },200)
    },
    clickmenu(item,index){
      item.child && item.child.map(val=>{
        val.checked = false
      })
      if(item.child && item.child[0]){
        item.child[0].checked = true
      }
        this.secondMenu = item
        this.activeIndex = index
        this.secondIndex = null

        if(index == this.navList.length - 1){
          this.isShow = true
        }else{
          this.isShow = false
        }
        this.secondIndex = 0
        if(item.child && item.child[0]){
          this.$router.push(item.child[0].page,()=>{}, ()=>{})
          this.$emit('menuItem',item.child[0],'1')
      }
    },
    secondMenuData(item,index){
      this.secondMenu.child.map(val=>{
        val.checked = false
        if(item.name == val.name){
          val.checked = true
        }
      })
        this.secondIndex = index
        this.$emit('menuItem',item)
    },
    goHome(){
      this.$router.push('/home',()=>{}, ()=>{})
      this.secondMenu = []
    }
    },
    mounted(){
        this.basic()
        this.pagefeed()
    }
}
</script>

<style scoped>
.menuBox{
    display: flex;
    height: 100vh !important;
    cursor: pointer;
}
.content{
  display: flex;
  flex-direction: column;
  flex: 1;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
}
.content::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
.secondListBox{
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  /* height: 20px; */
}
.content ul{
  /* margin-top: 20px; */
}
.content ul .default{
    padding: 9px 23px;
    font-size: 17px;
    color: #cacbd4;
    border-color: #fff;
    background-color: #1b213f;

}
.content ul .default:first-child{
    border-top-right-radius: 0px;
}
.content ul .active{
    padding: 9px 23px;
    font-size: 18px;
    background-color: #fff;
    color: #3861ab;
    font-weight: bold;
    font-size: 17px;
    position: relative;
}
.border-active-t {
    background: #2d2e36;
    border-bottom-right-radius: 10px;
	}

	.border-active-b {
    border-top-right-radius: 10px;
    background: #2d2e36;
	}
/* .content ul .active::before{
      content: '';
    width: 0;
    height: 0;
    position: absolute;
    top: -7px;
    right: 0;
    border: 5px solid #fff;
    border-top-color: transparent;
    border-left-color: transparent;
    border-radius: 5px;
}
.content ul .active::after{
    content: '';
    width: 0;
    height: 0;
    position: absolute;
    bottom: -7px;
    right: 0;
    border: 5px solid #fff;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-radius: 5px;

} */
img{
    width: 105px;
    display: inline-block;
}
.secondBox{
    width: 180px;
    font-size: 14px;
    /* background: #863838; */
}
.secondTitle{
    height: 40px;
    line-height: 40px;
    font-weight: bold;
    font-size: 16px;
    border-bottom: 1px solid #ebebeb;
    position:sticky;
    top: 0;
    background: #fff;
}
.secondList{
    display: inline-block;
    padding: 13px;
}
.secondBox img{
  width: 20px;
  height: 20px;
  margin-right: 20px;
}
.secondText{
    color: #3861ab;
    background: #e6eaf3;
}
.imgBox{
  position:sticky;
  top: 0;
  background: #1b213f;
  z-index: 999;
}

</style>


// WEBPACK FOOTER //
// src/components/menu.vue